module.exports = __webpack_public_path__ + "static/media/virtualexhangeio.c45e89b2.png";